import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable()
export class WorkOrderRequiredCompetencyService {

  constructor(private http: HttpClient) { }

  public getByWorkOrder(workOrderId: number) {
    return this.http
      .get(environment.competencyApiUrl + 'api/work-order-required-competency/by-work-order/' + workOrderId)
      .pipe(catchError(this.handleError));
  }

  public getTurbineManufacturers() {
    return this.http
      .get(environment.competencyApiUrl + 'api/turbine/manufacturer')
      .pipe(catchError(this.handleError));
  }

  public searchTurbines(body: { manufacturer?: string; name?: string; model?: string }) {
    return this.http
      .post(environment.competencyApiUrl + 'api/turbine/search', body)
      .pipe(catchError(this.handleError));
  }

  public createRequiredCompetency(body: any) {
    return this.http
      .post(environment.competencyApiUrl + 'api/work-order-required-competency', body)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
